/* eslint-disable storybook/default-exports */
import { frontendURL } from '../../helper/URLHelper';

const SearchView = () => import('./components/SearchView.vue');
const SearchContactView = () => import('./components/SearchContactView.vue');

export const routes = [
  {
    path: frontendURL('accounts/:accountId/search'),
    name: 'search',
    roles: ['administrator', 'agent'],
    component: SearchView,
  },
  {
    path: frontendURL('accounts/:accountId/search-contact-view'),
    name: 'search-contact-view',
    roles: ['administrator', 'agent'],
    component: SearchContactView,
  },
];
